/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable import/no-cycle */
import React, { useState, useEffect, useContext } from 'react';
import { Rnd } from 'react-rnd';
import { Box, MenuItem, Select, Modal, Stack, Grid, Button, Tooltip, Checkbox, ToggleButton, ToggleButtonGroup, Typography, styled, Switch, FormControlLabel, Radio, RadioGroup, Tab } from '@mui/material';
import { VeoliaInput } from '@veolia.com/vds-react-components';
import { TabContext, TabPanel, TabList } from '@mui/lab';
import { closeIconBlack, feed_water } from '../../shared/assets/images';
import { defaultModalOptions, defaultUnitValues } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import './parametric.scss';
import { ExecuteContext } from '../Flow';
import BatchSimulationResults from './batch_result';

const outputData = [{
  type: 'customnode_feed',
  data: [{ value: 'temp', label: 'Temperature' }, { value: 'ph', label: 'pH' }],
  selected_val: {
    start_val: 0,
    end_val: 0,
    no_of_step: 0,
    drop_select: '',
    step_select: false,
  }
}, {
  type: 'customnode_ROpump',
  data: [{ value: 'rec', label: 'Array Recovery' }],
  selected_val: {
    start_val: '',
    end_val: '',
    no_of_step: '',
    drop_select: '',
    step_select: false,
  }
}, {
  type: 'customnode_chemical_dosing',
  data: [{ value: 'target_ph', label: 'Target pH' }, { value: 'target_dosage', label: 'Dosage Rate' }],
  selected_val: {
    start_val: '',
    end_val: '',
    no_of_step: '',
    drop_select: '',
    step_select: false,
  }
}, {
  type: 'customnode_stripper',
  data: [{ value: 'co2', label: 'Outlet CO2 concentration' }, { value: 'nh3', label: 'Outlet NH3 concentration' }],
  selected_val: {
    start_val: '',
    end_val: '',
    no_of_step: '',
    drop_select: '',
    step_select: false,
  }
}];

const ParametricStudy = (props) => {
  const { visibleParametric, handleCloseParametric, inputOutputFlag, translateObject, element, edges, openModelPopUp, ediOutputData } = props;
  const executeParametricData = useContext(ExecuteContext);
  const [isShowErrorMessage] = useState(true);
  const [selectedValue, setSelectedValue] = useState('');
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [para_enable, setPara_enable] = React.useState(false);
  const [firstTime, setfirstTime] = React.useState(true);
  const [parametric_loop_data, setParametricLoopData] = useState([]);
  const [Chartvalue, setChartValue] = useState('0'); // we are selecting dosage kg/day
  useEffect(() => {
    const result = element
      .map((node) => {
        const match = outputData.find((item) => item.type === node.type);
        return match ? {
          id: node.id,
          name: match.type,
          data: match.data || [],
          selected_val: match.selected_val
        } : null;
      }).filter(Boolean);
    setParametricLoopData(result);
  }, [element, outputData]);
  useEffect(() => {
    if (executeParametricData.parametric_study && executeParametricData.parametric_study.batch_sim) {
      if (parametric_loop_data.length > 0 && firstTime) {
        setfirstTime(false);
        const data = executeParametricData.parametric_study.batch_sim;
        const key = Object.keys(data);
        parametric_loop_data.map((ele, ind) => {
          if (localStorage.getItem(ele.id) === key[0]) {
            setPara_enable(true);
            setSelectedValue(key[0]);
            setParametricLoopData((prev) => {
              const updated = [...prev];
              updated[ind] = {
                ...updated[ind], // keep existing properties of the item
                selected_val: {
                  ...updated[ind].selected_val, // keep existing properties of selected_val
                  drop_select: data[key[0]].type,
                  end_val: data[key[0]].end_value,
                  start_val: data[key[0]].start_value,
                  no_of_step: data[key[0]].size,
                  step_select: !data[key[0]].is_step_size,
                }
              };
              // Return the updated array to set new state
              return updated;
            });
          }
        });
      }
    }
  }, [parametric_loop_data, firstTime]);
  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#002d62' : '#002d62',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 500,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.mode === 'dark' ? '#002d62' : '#002d62',
      boxSizing: 'border-box',
    },
  }));
  // Function to close Parametric form
  const handleClose_Parametric_Form = () => {
    // Check whether error message is currently shown
    if (isShowErrorMessage) {
      // Store flag in localStorage to indicate global exit button action
      localStorage.setItem('globalExitBtn', 'true');
    }
    // Call function to close parametric form/modal
    handleCloseParametric();
  };
  // Function to handle close action for Parametric modal
  const handleCloseParametricModal = () => {
    // Check whether error message is shown
    if (isShowErrorMessage) {
      // Open confirmation modal with custom options
      setModalOption({
        // Spread default modal configuration
        ...defaultModalOptions,
        // Make modal visible
        visible: true,
        // Set confirmation message
        message: translateObject('Are you sure you want to close this form?'),
        // Action to perform when user clicks Yes
        onYes: () => handleClose_Parametric_Form(),
        // Action to perform when user clicks No
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      // If no error message, directly close parametric form/modal
      handleCloseParametric();
    }
  };

  const getKeyByValue = (value) => {
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (localStorage.getItem(key) === value) {
        return key;
      }
    }
    return null;
  };

  // Function to submit form
  const submitForm = (closeForm = true) => {
    // closeForm parameter is true by default
    // Add form submission logic here
    const activeVal = getKeyByValue(selectedValue);
    const finalVal = parametric_loop_data.filter((ele) => {
      return ele.id === activeVal;
    });
    if (finalVal.length) {
      if (finalVal[0].selected_val.drop_select) {
        console.log(finalVal[0].selected_val.step_select);
        if (finalVal[0].selected_val.step_select && Number(finalVal[0].selected_val.no_of_step) <= 1) {
          openModelPopUp('Number of step should be > 1', 'Warning', 'warning');
          return false;
        }
        const ui_data = {
          batch_sim: {
            [selectedValue]: {
              end_value: Number(finalVal[0].selected_val.end_val) || 0,
              start_value: Number(finalVal[0].selected_val.start_val) || 0,
              size: Number(finalVal[0].selected_val.no_of_step) || 0,
              type: finalVal[0].selected_val.drop_select,
              is_step_size: !finalVal[0].selected_val.step_select || false,
            }
          }
        };
        executeParametricData.parametric_study = ui_data;
        setfirstTime(false);
        handleCloseParametric();
      } else {
        openModelPopUp('Select Drop-down value', 'Warning', 'warning');
      }
    } else {
      openModelPopUp('Select Any One', 'Warning', 'warning');
      executeParametricData.parametric_study = {};
    }
  };

  // Handle change event for parametric dropdown
  const handleChangeParametric = (event, ind, str) => {
    // Get the selected value from the dropdown as a string
    let selectedValue;
    if (str === 'step_select') {
      selectedValue = event.target.checked;
    } else {
      selectedValue = String(event.target.value);
    }
    // Update state immutably using the setter function
    setParametricLoopData((prev) => {
      // Create a shallow copy of the previous state array
      const updated = prev.map((ele, idx) => {
        // Reset drop_select for all items
        return {
          ...ele,
          selected_val: {
            ...ele.selected_val,
            [str]: '' // clear existing value
          }
        };
      });
      // Update the specific item at index `ind` with the new selected value
      updated[ind] = {
        ...updated[ind], // keep existing properties of the item
        selected_val: {
          ...updated[ind].selected_val, // keep existing properties of selected_val
          [str]: selectedValue    // overwrite drop_select with new value
        }
      };
      // Return the updated array to set new state
      return updated;
    });
  };

  // Common change handler function
  const handleChange = (event, str, ind = 0) => {
    // Check if the changed field is step_select
    if (str === 'step_select') {
      handleChangeParametric(event, ind, str);
      // Check if the changed field is para_enable
    } else if (str === 'para_enable') {
      // Update para_enable state using checkbox checked value
      setPara_enable(event.target.checked);
      // Reset selected radio/dropdown value when para_enable changes
      setSelectedValue('');
    }
  };

  const changeInputVal = (e, para_ind, str) => {
    handleChangeParametric(e, para_ind, str);
  };
  const handleChangeTabList = (event, newValue) => {
    console.log(event, newValue);
    setChartValue(newValue);
  };
  return (
    <Modal
      hideBackdrop
      open={visibleParametric}
      className='splitter-modal'
    >
      <TabContext value={Chartvalue}>
        <Box className=''>
          <Rnd
            default={{
              width: '85%',
              x: ((window.innerWidth / 2) - ((85 * (window.innerWidth / 100)) / 2)),
              y: ((window.innerHeight / 2) - ((75 * (window.innerHeight / 100)) / 2)),
            }}
            enableResizing={{
              bottom: false, bottomLeft: false, bottomRight: false,
              left: true, right: true,
              top: false, topLeft: false, topRight: false
            }}
            allowAnyClick
            enableUserSelectHack={false}
            resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
            minWidth='40%'
            cancel=".no_drag, .MuiOutlinParametricInput-root"
            resizeHandleClasses={{
              'left': 'left_string',
              'right': 'right_string'
            }}
            className='parametric-box'>
            <Notification
              options={modalOption}
              handleClose={() => setModalOption(defaultModalOptions)}
            />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <TabList onChange={handleChangeTabList} aria-label="visible arrows tabs example" className='tab-list'>
                <Tab label='Parametric Study' color='default' value='0' className='B_Bold' />
                <Tab label='Batch Results' color='default' value='1' className='B_Bold' />
              </TabList>
              <div className='parametric-grid-container no_drag' style={{ paddingRight: 10 }}>
                <Tooltip title='Close'>
                  <img
                    src={closeIconBlack}
                    alt='close'
                    onClick={handleCloseParametricModal}
                    style={{ width: '14px', padding: '11px' }}
                    className='pointer'
                  />
                </Tooltip>
              </div>
            </div>
            <TabPanel value="0" className='tab-panel'>
              <Grid container className='parametric-grid-container parametric-wrapper'>
                <Grid item xs={12} className='parametric-header-grid'>
                  <div className='parametric-grid-title rufusBld no_drag S_heading'>Parametric Study</div>
                </Grid>
                <Grid item xs={12} className='parametric-body-container sansW4SeLig'>
                  <Grid item xs={12}>
                    <div className='parametric-iobuttons'>
                      <Stack className='no_drag' direction="row" spacing={1} alignItems="center" style={{ marginTop: '2%' }}>
                        <AntSwitch
                          inputProps={{ 'aria-label': 'ant design' }}
                          checked={para_enable}
                          onChange={(e) => handleChange(e, 'para_enable')}
                        />
                        <Typography style={{
                          'fontWeight': !para_enable ? 400 : 600, color: !para_enable ? '#1C1C1F' : '#002D62'
                        }}>{translateObject(!para_enable ? 'Disabled' : 'Enable')}</Typography>
                      </Stack>
                    </div>
                    <div className='parametric-input-form' style={{ 'overflowY': 'auto' }}>
                      {/* <Grid container item xs={12} spacing={1} className='output-top-container' style={{ marginTop: '0.5%' }}> */}
                      <Grid container spacing={2} style={{ marginTop: '0.5%' }} className="para_box-wrap">
                        {parametric_loop_data.map((ele, para_ind) => {
                          return (
                            <div className={`input-params ${!para_enable ? 'para-is-disabled' : ''}`}>
                              {!para_enable && <div className="disable-overlay" aria-hidden="true" />}
                              <div className={`grid-container  ${(selectedValue === localStorage.getItem(ele.id) && 'active-border')}`}>
                                <div className='input-select-grid'>
                                  <div className='para_feed'>
                                    <FormControlLabel
                                      control={
                                        <Radio
                                          name="my-radio"
                                          value={localStorage.getItem(ele.id)}
                                          checked={selectedValue === localStorage.getItem(ele.id)}
                                          onChange={(e) => setSelectedValue(e.target.value)}
                                        />
                                      }
                                      label={localStorage.getItem(ele.id)}
                                    />
                                  </div>
                                  <div className='para_input' style={{ pointerEvents: selectedValue !== localStorage.getItem(ele.id) ? 'none' : 'auto' }}>
                                    <VeoliaInput type="number" placeholder='Start Value' className='set-widt' inputGroupClassName="responsive" value={ele.selected_val.start_val} onChange={(e) => changeInputVal(e, para_ind, 'start_val')} />
                                    <span className='addon'>0.0</span>
                                  </div>
                                </div>
                                <div className='input-select-grid' style={{ pointerEvents: selectedValue !== localStorage.getItem(ele.id) ? 'none' : 'auto' }}>
                                  <div className='para_feed'>
                                    <Select
                                      key={ele.id || para_ind}
                                      inputProps={{ 'aria-label': 'Without label' }}
                                      value={String(ele.selected_val?.drop_select || '')}
                                      name="waterSource"
                                      style={{ width: '90%', height: '25px' }}
                                      fullWidth
                                      className="parametric_select"
                                      onChange={(event) => handleChangeParametric(event, para_ind, 'drop_select')}
                                      data-testid={`waterSource-${para_ind}`}
                                    >
                                      {ele.data.map((val) => (
                                        <MenuItem key={val.value} value={String(val.value)}>
                                          <span
                                            dangerouslySetInnerHTML={{
                                              __html: translateObject(val.label)
                                            }}
                                          />
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </div>
                                  <div className='para_input'>
                                    <VeoliaInput className='set-widt' placeholder='End Value' inputGroupClassName="responsive" value={ele.selected_val.end_val} onChange={(e) => changeInputVal(e, para_ind, 'end_val')} />
                                    <span className='addon'>0.0</span>
                                  </div>
                                </div>
                                <div className='input-select-grid' style={{ pointerEvents: selectedValue !== localStorage.getItem(ele.id) ? 'none' : 'auto' }}>
                                  <div className='para_feed'>
                                    <Stack className='no_drag' direction="row" spacing={1} alignItems="center" style={{ marginTop: '2%' }}>
                                      <Typography className='ft13' style={{
                                        'fontWeight': ele.selected_val.step_select ? 400 : 600, color: ele.selected_val.step_select ? '#1C1C1F' : '#002D62'
                                      }}>{translateObject('Step Size')}</Typography>
                                      <AntSwitch
                                        inputProps={{ 'aria-label': 'ant design' }}
                                        checked={ele.selected_val.step_select}
                                        onChange={(e) => handleChange(e, 'step_select', para_ind)}
                                      />
                                      <Typography className='ft13' style={{
                                        'fontWeight': !ele.selected_val.step_select ? 400 : 600, color: !ele.selected_val.step_select ? '#1C1C1F' : '#002D62'
                                      }}>{translateObject('No of Step')}</Typography>
                                    </Stack>
                                  </div>
                                  <div className='para_input'>
                                    <VeoliaInput className='set-widt' placeholder='No of Step' inputGroupClassName="responsive" value={ele.selected_val.no_of_step} onChange={(e) => changeInputVal(e, para_ind, 'no_of_step')} />
                                    <span className='addon'>0.0</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        {/* </Grid> */}
                      </Grid>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className='parametric-button'>
                      <Stack spacing={2} direction='row'>
                        <Button variant='contained M_Bold Secondary-Default_button btn-auto-width' size='small' className=' sansW4SeLig'
                          style={{ border: 'none' }}
                          onClick={handleCloseParametricModal}> {translateObject('Cancel')} </Button>
                        <Button variant='contained M_Bold Primary_Default_Button btn-auto-width' size='small' className=' sansW4SeLig'
                          onClick={submitForm}> {translateObject('Submit')} </Button>
                      </Stack>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </TabPanel>
            <TabPanel value="1" className='tab-panel'>
              <BatchSimulationResults
                translateObject={translateObject}
                ediOutputData={ediOutputData}
                handleCloseParametric={handleCloseParametric}
              />
            </TabPanel>
          </Rnd>
        </Box>
      </TabContext>
    </Modal >
  );
};
export default ParametricStudy;
